// roleRoutes.js
export const roleRoutes = {
  appOwner: "/owner",
  admin: "/admin",
  teacher: "/teacher",
  receptionist: "/receptionist",
  student: "/student",
  parent: "/parent",
  principal: "/workspace",
  manager: "/workspace",
  coordinator: "/workspace",
  operator: "/workspace",
};

// export const rolePermissions = {
//   admin: ["/admin", "/users", "/reports", "/settings"],
//   appOwner: ["/owner", "/schools", "/assign-admin"],
//   teacher: ["/teacher", "/classes", "/attendance"],
//   receptionist: ["/receptionist", "/students", "/appointments"],
//   student: ["/student", "/subjects", "/assignments"],
// };
